import React, { useState } from 'react'

import RowDetailModal from '../modals/RowDetailModal'
import DataGridTable from './DataGridTable'

import { DataTableSection } from '../../styles/components/DataTableStyle'

const DataTable = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [clickedSequenceId, setClickedSequenceId] = useState('')
  const [clickedRowIndex, setClickedRowIndex] = useState(null)
  const [updatedItemIndex, setUpdatedItemIndex] = useState([])

  const handleModal = () => {
    if (isModalOpen) {
      setClickedSequenceId('')
      setClickedRowIndex(null)
    }
    setIsModalOpen(!isModalOpen)
  }

  return (
    <DataTableSection>
      <DataGridTable
        handleModal={handleModal}
        setClickedSequenceId={setClickedSequenceId}
        setClickedRowIndex={setClickedRowIndex}
        updatedItemIndex={updatedItemIndex}
      />

      {isModalOpen && (
        <RowDetailModal
          clickedRowIndex={clickedRowIndex}
          isModalOpen={isModalOpen}
          handleModal={handleModal}
          sequenceId={clickedSequenceId}
          setUpdatedItemIndex={setUpdatedItemIndex}
        />
      )}
    </DataTableSection>
  )
}

export default DataTable
